export * from './opi-trigger-type.interface';
